import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import {
  ControlGpAction,
  controlGpAction,
  controlGpDtlAction,
  controlGpFlightPlanAction,
  controlGpFlightPlanInitAction,
  controlGpFlightPlanWarnAction,
  controlGpLogAction,
  controlGpHisAction,
  controlGpRtDtlAction,
  // controlGroupAuthAction,
  controlGpArcrftWarnAction,
  controlweatherAction,
  controlGpCountAction
} from '../actions/controlGpAction';
import {
  ControlGpWarnLogData,
  ControlDetailData,
  rescontrolweatherData,
  ControlGpDtlState,
  ControlGpFlightPlanState,
  ControlGpLogState,
  ControlGpHisState,
  ControlGpState,
  // ControlGroupAuthState,
  initiaResponseControlGpData,
  ControlGpCountState,
  ControlGpCountData
} from '../models/controlGpModel';

export const controlGpReducer = createReducer<ControlGpState, ControlGpAction>(
  initiaResponseControlGpData
).handleAction(controlGpAction.success, (state, action) =>
  produce(state, draft => {
    const { controlGpList, controlGroupAuthInfo } = action.payload;
    draft.controlGpList = controlGpList;
    draft.controlGroupAuthInfo = controlGroupAuthInfo;
  })
);

export const controlGpFltPlanReducer = createReducer<
  ControlGpFlightPlanState,
  ControlGpAction
>(initiaResponseControlGpData)
  .handleAction(controlGpFlightPlanAction.success, (state, action) =>
    produce(state, draft => {
      const list = action.payload;
      draft.controlGpFltPlanList = list;
    })
  )
  .handleAction(controlGpFlightPlanInitAction, (state, action) =>
    produce(state, draft => {
      draft.controlGpFltPlanList = undefined;
    })
  )
  .handleAction(controlGpFlightPlanWarnAction.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.controlGpContains = data;
    })
  );

export const controlGpLogReducer = createReducer<
  ControlGpLogState,
  ControlGpAction
>(initiaResponseControlGpData)
  .handleAction(controlGpLogAction.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.controlGpWarnLog = data;
    })
  )
  .handleAction(controlGpArcrftWarnAction.success, (state, action) =>
    produce(state, draft => {
      const list = action.payload;
      draft.controlGpArcrftWarnList = list;
    })
  );

export const controlGpHisReducer = createReducer<
  ControlGpHisState,
  ControlGpAction
>(initiaResponseControlGpData).handleAction(
  controlGpHisAction.success,
  (state, action) =>
    produce(state, draft => {
      const { controlGpHistory } = action.payload;
      draft.controlGpHistory = controlGpHistory;
    })
);

export const controlGpDtlReducer = createReducer<
  ControlGpDtlState,
  ControlGpAction
>(initiaResponseControlGpData)
  .handleAction(controlGpRtDtlAction.success, (state, action) =>
    produce(state, draft => {
      const { controlGpDetail } = action.payload;

      draft.controlGpDetail = controlGpDetail;
    })
  )
  .handleAction(controlGpDtlAction.success, (state, action) =>
    produce(state, draft => {
      const data: ControlDetailData = action.payload;
      draft.controlDetail = data;
    })
  )
  .handleAction(controlweatherAction.success, (state, action) =>
    produce(state, draft => {
      const data: rescontrolweatherData = action.payload;
      draft.controlWheather = data;
    })
  );

export const controlGpCountReducer = createReducer<ControlGpCountState>(
  initiaResponseControlGpData
).handleAction(controlGpCountAction.success, (state, action) =>
  produce(state, draft => {
    const drone: ControlGpCountData = action.payload.count.drone;
    const flight: ControlGpCountData = action.payload.count.flight;

    draft.controlGpCountDrone = drone;
    draft.controlGpCountFlight = flight;
  })
);
// export const controlGroupAuthReducer = createReducer<
//   ControlGroupAuthState,
//   ControlGpAction
// >(initiaResponseControlGpData).handleAction(
//   controlGroupAuthAction.success,
//   (state, action) =>
//     produce(state, draft => {
//       const { controlGroupAuthInfo } = action.payload;

//       draft.controlGroupAuthInfo = controlGroupAuthInfo;
//     })
// );
